import { ChangeDetectionStrategy, Component, effect, input, viewChild } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS, MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { ErrorStateMatcher } from '@angular/material/core';
import { CdkTextareaAutosize } from '@angular/cdk/text-field';

import { FieldErrorStateMatcher } from '@rp/utils';
import { TranslateModule } from '@ngx-translate/core';

import { InputComponent } from '../../input.component';

@Component({
  selector: 'rp-textarea',
  standalone: true,
  templateUrl: './textarea.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatFormFieldModule, MatInputModule, ReactiveFormsModule, TranslateModule],
  providers: [
    { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { floatLabel: 'always' } },
    { provide: ErrorStateMatcher, useClass: FieldErrorStateMatcher },
  ],
})
export class TextareaComponent extends InputComponent {
  textareaAutosize = viewChild<CdkTextareaAutosize>('textareaAutosize');

  rows = input<number>(3);
  maxRows = input<number>(3);

  constructor() {
    super();

    effect(() => {
      // Fix textarea height ( BND-2974 )
      if (this.textareaAutosize()) {
        this.textareaAutosize()['_cachedPlaceholderHeight'] = undefined;

        this.textareaAutosize().resizeToFitContent(true);
      }
    });
  }
}
